var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c(
        "w-row",
        [
          _c(
            "w-col",
            [
              _c("app-label", {
                attrs: {
                  label: _vm.$ct("labels.CompanyName"),
                  value: _vm.contactAddress.CompanyName,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12", md: "6" } },
            [
              _c("app-label", {
                attrs: {
                  label: _vm.$ct("labels.Firstname"),
                  value: _vm.contactAddress.FirstName,
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "12", md: "6" } },
            [
              _c("app-label", {
                attrs: {
                  label: _vm.$ct("labels.LastName"),
                  value: _vm.contactAddress.LastName,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            [
              _c("app-label", {
                attrs: {
                  label: _vm.$ct("labels.AddressLine1"),
                  value: _vm.contactAddress.AddressLine1,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            [
              _c("app-label", {
                attrs: {
                  label: _vm.$ct("labels.AddressLine2"),
                  value: _vm.contactAddress.AddressLine2,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "5" } },
            [
              _c("app-label", {
                attrs: {
                  label: _vm.$ct("labels.Postal"),
                  value: _vm.contactAddress.Postal,
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "7" } },
            [
              _c("app-label", {
                attrs: {
                  label: _vm.$ct("labels.City"),
                  value: _vm.contactAddress.City,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._l(_vm.mails, function (mail, i) {
        return _c(
          "w-row",
          { key: i },
          [
            _c("w-col", { attrs: { xs: "12" } }, [
              _c(
                "div",
                { staticClass: "row" },
                [
                  _c("app-label", {
                    staticClass: "mr grow",
                    attrs: { label: _vm.getMailLabel(i), value: mail },
                  }),
                  _c(
                    "w-button",
                    {
                      directives: [
                        {
                          name: "tooltip",
                          rawName: "v-tooltip",
                          value: _vm.$ct("send-mail"),
                          expression: "$ct('send-mail')",
                        },
                      ],
                      attrs: { disabled: !mail },
                      on: {
                        click: function ($event) {
                          return _vm.openSendMessageModal(mail)
                        },
                      },
                    },
                    [_c("w-fa", { attrs: { icon: "envelope" } })],
                    1
                  ),
                ],
                1
              ),
            ]),
          ],
          1
        )
      }),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12", md: "6" } },
            [
              _c("app-label", {
                attrs: {
                  label: _vm.$ct("labels.Phone"),
                  value: _vm.contactAddress.Phone,
                },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "12", md: "6" } },
            [
              _c("app-label", {
                attrs: {
                  label: _vm.$ct("labels.Mobile"),
                  value: _vm.contactAddress.Mobile,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            [
              _c("app-label", {
                attrs: {
                  label: _vm.$ct("labels.Fax"),
                  value: _vm.contactAddress.Fax,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            [
              _c("app-label", {
                attrs: {
                  label: _vm.$ct("labels.Reference"),
                  value: _vm.contactAddress.Reference,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-row",
        [
          _c(
            "w-col",
            { attrs: { xs: "12", md: "6" } },
            [
              _c("app-label", {
                attrs: { label: _vm.$ct("labels.Country"), value: _vm.country },
              }),
            ],
            1
          ),
          _c(
            "w-col",
            { attrs: { xs: "12", md: "6" } },
            [
              _c("app-label", {
                attrs: {
                  label: _vm.$ct("labels.Lng"),
                  value: _vm.contactAddress.Lng,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        { attrs: { value: _vm.sendMessageDialogMail != "" } },
        [
          _vm.sendMessageDialogMail
            ? _c("app-send-message-dialog", {
                attrs: { to: _vm.sendMessageDialogMail },
                on: {
                  close: function ($event) {
                    return _vm.closeSendMessageDialog()
                  },
                  sent: function ($event) {
                    return _vm.closeSendMessageDialog()
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }